// Libraries
import React from 'react';

// Supermove
import {gql, useQuery} from '@supermove/graphql';
import {useNavigationDOM} from '@supermove/hooks';

// App
import CommunicationAccountsPage from 'modules/Organization/Settings/Communication/components/CommunicationAccounts/CommunicationAccountsPage';
import EmailTemplatesPage from 'modules/Organization/Settings/Communication/components/EmailTemplatesPage';
import OrganizationSettingsCallIntegrationsPage from 'modules/Organization/Settings/Communication/components/OrganizationSettingsCallIntegrationsPage';
import OrganizationSettingsCommunicationGeneralPage from 'modules/Organization/Settings/Communication/components/OrganizationSettingsCommunicationGeneralPage';
import SmsTemplatesPage from 'modules/Organization/Settings/Communication/components/SmsTemplatesPage';
import SettingsPage from 'modules/Organization/Settings/components/SettingsPage';

const TABS = {
  GENERAL: 'general',
  EMAIL_TEMPLATES: 'email-templates',
  SMS_TEMPLATES: 'sms-templates',
  CALL_INTEGRATIONS: 'call-integrations',
  ACCOUNTS: 'accounts',
};

const PageContent = () => {
  const {params} = useNavigationDOM();

  switch (params.tab) {
    case TABS.GENERAL:
      return <OrganizationSettingsCommunicationGeneralPage />;
    case TABS.EMAIL_TEMPLATES:
      return <EmailTemplatesPage />;
    case TABS.SMS_TEMPLATES:
      return <SmsTemplatesPage />;
    case TABS.CALL_INTEGRATIONS:
      return <OrganizationSettingsCallIntegrationsPage />;
    case TABS.ACCOUNTS:
      return <CommunicationAccountsPage />;
    default:
      return null;
  }
};

const OrganizationSettingsCommunicationPage = () => {
  const {navigator} = useNavigationDOM();
  const {data} = useQuery(OrganizationSettingsCommunicationPage.query, {
    fetchPolicy: 'cache-and-network',
  });

  return (
    <SettingsPage
      breadcrumbs={[
        {name: 'Settings', onPress: () => navigator.push('/settings')},
        {name: 'Communication'},
      ]}
      tabs={[
        {
          label: 'General',
          url: `/settings/communication/${TABS.GENERAL}`,
        },
        ...(data?.viewer.viewingOrganization.features.isEnabledMultiAccountGrantSending
          ? [
              {
                label: 'Accounts',
                url: `/settings/communication/${TABS.ACCOUNTS}`,
              },
            ]
          : []),
        {
          label: 'Email Templates',
          url: `/settings/communication/${TABS.EMAIL_TEMPLATES}`,
        },
        {
          label: 'SMS Templates',
          url: `/settings/communication/${TABS.SMS_TEMPLATES}`,
        },
        ...(data?.viewer.viewingOrganization.features.isEnabledSalesCallIntegrations
          ? [
              {
                label: 'Call Integrations',
                url: `/settings/communication/${TABS.CALL_INTEGRATIONS}`,
              },
            ]
          : []),
      ]}
      hasNoChildrenStyle
    >
      <PageContent />
    </SettingsPage>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
OrganizationSettingsCommunicationPage.query = gql`

  query OrganizationSettingsCommunicationPage {
    ${gql.query}
    viewer {
      id
      viewingOrganization {
        id
        features {
          isEnabledMultiAccountGrantSending: isEnabled(feature: "MULTI_ACCOUNT_GRANT_SENDING")
          isEnabledSalesCallIntegrations: isEnabled(feature: "SALES_CALL_INTEGRATIONS")
        }
      }
    }
  }
`;

export default OrganizationSettingsCommunicationPage;
